import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=2d4be284&scoped=true"
import script from "./AppointmentsList.vue?vue&type=script&lang=js"
export * from "./AppointmentsList.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsList.vue?vue&type=style&index=0&id=2d4be284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4be284",
  null
  
)

export default component.exports